import { colors } from 'shared/assets/styles'
import { TickIcon } from 'app-v2/assets/icons/Tick'
import { ScanIcon } from 'app-v2/assets/icons'
import React from 'react'
import { Spinner } from '../../../../assets/icons'
import styled from 'styled-components'

type QrButtonProps = {
    mode: 'qr' | 'send',
    onQrClick: () => void,
    loading?: boolean
}

export const QrButton = ({ mode, onQrClick, loading }: QrButtonProps) => {
    return (
        <StyledInputButtonContainer>
            <StyledScanIconButton
                type={mode === 'send' ? 'submit' : 'button'}
                onClick={mode === 'qr' ? onQrClick : undefined}
                disabled={loading}
                color={
                    mode === 'send'
                        ? loading
                            ? colors.crunchyGreenDisabled
                            : colors.crunchyGreen
                        : colors.transparent
                }>
                {mode === 'send' ? (
                    loading ? (
                        <Spinner color={colors.white} size={24} />
                    ) : (
                        <TickIcon size={12} color={colors.white} />
                    )
                ) : (
                    <ScanIcon size={24} color={colors.bbqBrown} />
                )}
            </StyledScanIconButton>
        </StyledInputButtonContainer>
    )
}

const StyledInputButtonContainer = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
`

const StyledScanIconButton = styled.button`
    ${({ color }) =>
        color
            ? `background: ${color};`
            : `background: transparent;
`}
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    padding: 0;
    height: 32px;
    width: 32px;
`
